<div class="d-flex align-items-center">
    <div class="me-2">{{data.missionTitle}}</div>
  <svg-icon *ngIf="data?.isurgent" src="/assets/icons/redFlag.svg"></svg-icon>
    
</div>